import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import classNames from 'classnames';
import Metrics from '@spotahome/soyuz-metrics';

import homeCardListStyle from '../HomeCardList/HomeCardList.scss';

import HomeCardBannerFront from './components/HomeCardBannerFront';
import HomeCardBannerBack from './components/HomeCardBannerBack';

import './HomeCardBanner.scss';

const HomeCardBanner = ({ dataObj }) => {
  const [isFlipped, setFlipped] = useState(false);
  const isWebView = useMediaQuery({
    query: `(min-width: ${homeCardListStyle.twoColumns})`
  });

  useEffect(() => {
    if (isFlipped) {
      Metrics.ga.sendEvent(...Object.values(dataObj.tracking));
    }
  }, [dataObj.tracking, isFlipped]);

  const homeCardBannerCn = classNames(
    'home-card-banner',
    isFlipped ? 'home-card-banner--flipped' : ''
  );

  return (
    <div className={homeCardBannerCn}>
      <div className="home-card-banner__wrapper">
        <div
          className="home-card-banner__side home-card-banner__side--back"
          onClick={() => setFlipped(!isFlipped)}
          role="button"
          tabIndex="0"
        >
          <HomeCardBannerBack
            bannerName={dataObj.name}
            Icon={dataObj.Icon}
            isWebView={isWebView}
          />
        </div>
        <div
          className="home-card-banner__side home-card-banner__side--front"
          onClick={() => setFlipped(!isFlipped)}
          role="button"
          tabIndex="0"
        >
          <HomeCardBannerFront
            bannerName={dataObj.name}
            isWebView={isWebView}
          />
        </div>
      </div>
    </div>
  );
};

HomeCardBanner.propTypes = {
  dataObj: PropTypes.shape({
    name: PropTypes.string,
    Icon: PropTypes.string,
    tracking: PropTypes.shape({
      eventCategory: PropTypes.string,
      eventAction: PropTypes.string,
      eventLabel: PropTypes.string,
      eventValue: PropTypes.string
    })
  }).isRequired
};

export default HomeCardBanner;
